import { InputType } from 'config'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { downloadTaxForms } from 'services'
import { Button, Checkbox, Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

export default function TaxForms() {
  const [loanDetail] = useSelector((state: any) => [state.loanDetail])

  const [loading, setLoading] = useState(false)
  const [selectedYear, setSelectedYear] = useState<string>('')
  const [showModal, setShowModal] = useState(false)
  const [modalUpdatedAt, setModalUpdatedAt] = useState(0)
  const [includeOriginationFee, setIncludeOriginationFee] = useState(true)
  const [includeDiscountPoints, setIncludeDiscountPoints] = useState(true)

  const currentYear = new Date().getFullYear()
  const closingDateYear = loanDetail?.closingDate ? new Date(loanDetail.closingDate).getFullYear() : null

  const years = Array.from({ length: 10 }, (_, i) => currentYear - i).reduce((acc, year) => {
    acc[year] = String(year)
    return acc
  }, {} as Record<string, string>)

  const yearInput: InputType = {
    inputType: 'select',
    title: 'Select Year',
    value: selectedYear,
    options: years,
    hasDefaultOption: true,
    defaultOptionText: '-- Select a year --',
  }

  const handleSubmit = async () => {
    if (selectedYear) {
      if (Number(selectedYear) !== closingDateYear) {
        setLoading(true)
        try {
          await downloadTaxForms({
            year: Number(selectedYear),
            includeOriginationFee: false,
            includeDiscountPoints: false,
          })
        } catch (error) {
          console.error('Error downloading tax forms:', error)
        } finally {
          setLoading(false)
        }
      } else {
        setShowModal(true)
        setModalUpdatedAt(Date.now())
      }
    }
  }

  const handleConfirmSubmit = async () => {
    setLoading(true)
    try {
      await downloadTaxForms({
        year: Number(selectedYear),
        includeOriginationFee,
        includeDiscountPoints,
      })
    } catch (error) {
      console.error('Error downloading tax forms:', error)
    } finally {
      setLoading(false)
      setShowModal(false)
    }
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl flex items-center gap-1 font-bold mb-2">
          <span>Tax Forms</span>
        </h2>
      </div>

      <div className="space-y-4 w-full">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          <div>
            <RenderInput
              input={yearInput}
              Key="year"
              onChange={(key: string, value: string) => setSelectedYear(value)}
            />
          </div>
        </div>

        <div>
          <Button onClick={handleSubmit} disabled={!selectedYear} loading={loading}>
            Download
          </Button>
        </div>
      </div>

      <Modal
        isOpen={showModal}
        lastUpdatedAt={modalUpdatedAt}
        title="Download Tax Forms Options"
        titleOkay="Download"
        titleCancel="Cancel"
        onOk={handleConfirmSubmit}
        onCancel={() => setShowModal(false)}
        loading={loading}
        disabled={!includeOriginationFee && !includeDiscountPoints}
      >
        <div className="w-full max-w-[600px] space-y-4">
          <Checkbox
            id="includeOriginationFee"
            title="Include Origination Fee"
            checked={includeOriginationFee}
            onChange={(checked) => setIncludeOriginationFee(checked)}
          />
          <Checkbox
            id="includeDiscountPoints"
            title="Include Discount Points"
            checked={includeDiscountPoints}
            onChange={(checked) => setIncludeDiscountPoints(checked)}
          />
        </div>
      </Modal>
    </div>
  )
}
